// extracted by mini-css-extract-plugin
module.exports = {"banner":"Partners_banner__3dGwy","btn":"Partners_btn__1cmh6","itemsOnImg":"Partners_itemsOnImg__1D-MM"};